import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import { getSiteGraphqlUrl } from "@hooks/use-site-context/utils";

// loginClients returns a plain array of LoginClient objects.
// Fetch all clients and filter by provider on the frontend.
const GET_LOGIN_CLIENTS = gql`
  query GetLoginClients {
    loginClients {
      provider
      authorizationUrl
    }
  }
`;

const useLoginClientUrl = (provider: string) => {
  const [fetchClients, { loading, error }] = useLazyQuery(GET_LOGIN_CLIENTS, {
    context: { uri: getSiteGraphqlUrl() },
    fetchPolicy: "no-cache",
  });

  const getAuthorizationUrl = useCallback(async (): Promise<string | null> => {
    try {
      const result = await fetchClients();
      const clients: Array<{ provider: string; authorizationUrl: string }> =
        result.data?.loginClients ?? [];
      const match = clients.find(
        (c) => c.provider?.toLowerCase() === provider.toLowerCase()
      );
      if (!match?.authorizationUrl) {
        console.error(
          `[useLoginClientUrl] No authorizationUrl found for provider "${provider}". Clients returned:`,
          clients
        );
      }
      return match?.authorizationUrl ?? null;
    } catch (err) {
      console.error(`[useLoginClientUrl] query failed for provider "${provider}":`, err);
      return null;
    }
  }, [fetchClients, provider]);

  return { getAuthorizationUrl, loading, error };
};

export const useGoogleAuthUrl = () => useLoginClientUrl("google");
export const useMicrosoftAuthUrl = () => useLoginClientUrl("oauth2_generic");
